import SavedOutfits from '../../components/saved-items/saved-outfits.vue';
import SavedOutfit from '../../components/saved-items/saved-outfit.vue';
import PurchaseOutfitContainer from '../../components/outfit/purchase-outfit-container.vue';
import { SAVED_ITEMS_SUB_MENU_PAGES } from '../../config.js';

export default {
    path: '/saved-outfits',
    component: {
        render (c) {
            return c('router-view')
        }
    },
    meta: {
        requiresAuth: true,
    },
    children: [
        {
            path: '',
            meta: {
                requiresAuth: true,
                pages: SAVED_ITEMS_SUB_MENU_PAGES,
            },
            component: SavedOutfits
        },
        {
            path: 'outfit',
            meta: {
                requiresAuth: true
            },
            component: SavedOutfit,
        },
        {
            path: 'purchase-outfit',
            meta: {
                requiresAuth: true,
                savedOutfit: true
            },
            component: PurchaseOutfitContainer,
        }
    ]
};